import styled from "theme/libs/styled";
import Box from "theme/components/boxes/Box";

const GreigeBox = styled(Box)`
    background-color: ${({ theme }) => `${theme.colors.darkGreige}`};
    color: ${({ theme }) => `${theme.colors.black}`};
`;

GreigeBox.propTypes = Box.propTypes;
GreigeBox.defaultProps = Box.defaultProps;

export default GreigeBox;
